/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES プレスリリースエディタ API
 * PR TIMES 企業管理画面 プレスリリースエディタ用の API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PostPressReleaseImageSuccessResponseData,
    PostPressReleaseImageSuccessResponseDataFromJSON,
    PostPressReleaseImageSuccessResponseDataFromJSONTyped,
    PostPressReleaseImageSuccessResponseDataToJSON,
} from './PostPressReleaseImageSuccessResponseData';

/**
 * POST /press_release/{release_id}/image
 * @export
 * @interface PostPressReleaseImageResponse
 */
export interface PostPressReleaseImageResponse {
    /**
     * 
     * @type {number}
     * @memberof PostPressReleaseImageResponse
     */
    status: number;
    /**
     * 
     * @type {string}
     * @memberof PostPressReleaseImageResponse
     */
    message: string;
    /**
     * 
     * @type {PostPressReleaseImageSuccessResponseData}
     * @memberof PostPressReleaseImageResponse
     */
    data: PostPressReleaseImageSuccessResponseData;
}

export function PostPressReleaseImageResponseFromJSON(json: any): PostPressReleaseImageResponse {
    return PostPressReleaseImageResponseFromJSONTyped(json, false);
}

export function PostPressReleaseImageResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostPressReleaseImageResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'data': PostPressReleaseImageSuccessResponseDataFromJSON(json['data']),
    };
}

export function PostPressReleaseImageResponseToJSON(value?: PostPressReleaseImageResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'data': PostPressReleaseImageSuccessResponseDataToJSON(value.data),
    };
}

